// Module
var code = "<div> <div class=\"contextual-menu hidden-print\"> <wt-contextual-control fields=\"vm.properties\" form-controller=\"vm.formController\" has-property-types=\"true\" item=\"vm.configuration\" modern-design=\"true\" on-cancel=\"vm.onCancel()\" save=\"vm.onSave()\"> </wt-contextual-control> </div> </div>";
// Exports
module.exports = code;